import React, { useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";

let autoComplete;

const SearchLocationInput = ({ setSelectedLocation, initialQuery = "" }) => {
  const [query, setQuery] = useState(initialQuery); // Set initial query from props
  const autoCompleteRef = useRef(null);

  const handleScriptLoad = (updateQuery, autoCompleteRef) => {
    if (!window.google || !window.google.maps || !window.google.maps.places) return;
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      {
        componentRestrictions: { country: "USA" }, // Optional: Restrict to specific country
      }
    );
    autoComplete.addListener("place_changed", () => {
      handlePlaceSelect(updateQuery);
    });
  };

  const handlePlaceSelect = async (updateQuery) => {
    const addressObject = await autoComplete.getPlace();
    if (!addressObject || !addressObject.address_components) {
      return; // Handle cases where no address is selected
    }
    const formattedAddress = addressObject.formatted_address;
    const addressComponents = addressObject.address_components;
    // Extract relevant address components
    const getAddressComponent = (types) => {
      const component = addressComponents.find((comp) =>
        comp.types.some((type) => types.includes(type))
      );
      return component ? component.long_name : '';
    };
    const city = getAddressComponent(['locality', 'administrative_area_level_3']);
    const state = getAddressComponent(['administrative_area_level_1']);
    const country = getAddressComponent(['country']);
    const postalCode = getAddressComponent(['postal_code']);
    updateQuery(formattedAddress);
    setSelectedLocation(formattedAddress, city, state, country, postalCode);
  };

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries: ["places"],
    });
    loader.load().then(() => {
      handleScriptLoad(setQuery, autoCompleteRef);
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setQuery(initialQuery); // Update query when initialQuery changes
  }, [initialQuery]);

  return (
    <input
      ref={autoCompleteRef}
      onChange={(event) => {
        setQuery(event.target.value);
        setSelectedLocation(event.target.value);  
      }}
      placeholder="Search Street..."
      value={query || ""}
      autoComplete="off"
      required
      style={{ width: "100%", boxSizing: "border-box", padding: "8px", fontSize: "16px" }}  
    />
  );
};

export default SearchLocationInput;